import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import Button from '@atlaskit/button';
import { FilterShowMoreWrapper, FilterShowMoreButtonWrapper } from './filter-show-more.styled';
// todo - refactor out T
export var FilterShowMore = /*#__PURE__*/function (_React$Component) {
  _inherits(FilterShowMore, _React$Component);
  var _super = _createSuper(FilterShowMore);
  function FilterShowMore() {
    var _this;
    _classCallCheck(this, FilterShowMore);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      isEdit: false
    });
    _defineProperty(_assertThisInitialized(_this), "readViewRef", /*#__PURE__*/React.createRef());
    _defineProperty(_assertThisInitialized(_this), "setIsEdit", function (isEdit) {
      _this.setState({
        isEdit: isEdit
      });
    });
    _defineProperty(_assertThisInitialized(_this), "refocusEditLink", function () {
      return _this.focusTimeout = setTimeout(function () {
        var _this$readViewRef$cur;
        return (_this$readViewRef$cur = _this.readViewRef.current) === null || _this$readViewRef$cur === void 0 ? void 0 : _this$readViewRef$cur.focus();
      }, 0);
    });
    _defineProperty(_assertThisInitialized(_this), "onConfirm", function (value) {
      _this.refocusEditLink();
      return _this.props.addFilter(value);
    });
    _defineProperty(_assertThisInitialized(_this), "renderReadView", function () {
      return /*#__PURE__*/React.createElement(FilterShowMoreButtonWrapper, null, /*#__PURE__*/React.createElement(Button, {
        ref: _this.readViewRef,
        appearance: "link",
        onClick: function onClick() {
          return _this.setIsEdit(true);
        },
        isDisabled: _this.props.isDisabled
      }, _this.props.buttonText));
    });
    return _this;
  }
  _createClass(FilterShowMore, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.focusTimeout && clearTimeout(this.focusTimeout);
    }
  }, {
    key: "renderEditView",
    value: function renderEditView() {
      var _this2 = this;
      var FilterComponent = this.props.filterComponent;
      return /*#__PURE__*/React.createElement(FilterComponent, {
        defaultOptions: this.props.defaultOptions,
        loadOptions: this.props.loadOptions,
        placeholderText: this.props.placeholderText,
        onConfirm: this.onConfirm,
        onMenuClosed: function onMenuClosed() {
          _this2.setIsEdit(false);
        },
        refocusEditLink: this.refocusEditLink,
        loadingMessage: this.props.loadingMessage,
        noOptionsMessage: this.props.noOptionsMessage,
        onFocusAriaMessage: this.props.onFocusAriaMessage
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(FilterShowMoreWrapper, null, this.state.isEdit ? this.renderEditView() : this.renderReadView());
    }
  }]);
  return FilterShowMore;
}(React.Component);